import type { GridRenderCellParams } from "@mui/x-data-grid";
import css from "../../activation-status/useCustomRowDisplay.module.css";

// This cell renderer is intentionally generic: it only requires that params.value is a string
// Row type is set to `object` to allow reuse across work packet and case grids

export const StoreNameDisplay = (params: GridRenderCellParams<object, string>) => (
  <span>
    <span className={css.sunsetIcon}>🌅</span>
    <span className={css.deactivatedIcon}>🚫</span>
    <span>{params.value}</span>
  </span>
);
